<template>
    <paper class="performanceWaybillNodeMonitor">
        <div class="tooltip">亲爱的用户，【运单节点监控】将于2024年10月11日正式下线。我们建议您访问【运输单管理（新）】，若您有疑问也请及时联系产品经理梁海波（lianghb60）/18588841885。</div>
        <!-- 查询 -->
        <waybill-node-monitor-search
            ref="waybillNodeMonitorSearch"
            :searchId="searchId"
            :config="config"
            @searchChange="searchChange"
            @tableConfigChange="tableConfigChange"
            @export="handleExport"
        ></waybill-node-monitor-search>
        <div class="waybillNodeMonitorWrapper">
            <div
                class="waybillNodeMonitorLeft"
                style="width: 100%"
            >
                <!-- 表格 -->
                <waybill-node-monitor-table
                    :config="config"
                    :tableData="tableData"
                    :loading="loading"
                    :columnLabelStr="columnLabelStr"
                    @view-log="handleViewLog"
                >
                </waybill-node-monitor-table>
            </div>
            <!-- 运单汇总 -->
            <!-- <div
                class="waybillNodeMonitorRight"
                :style="
                    isExpand
                        ? `width: 22%;transform: translate3d(0, 0, 0)`
                        : `width: 0px;transform: translate3d(calc(100% + 16px),0px,0)`
                "
            >
                <way-bill-summary
                    ref="wayBillSummary"
                    :exceptionNumber="exceptionNumber"
                    :processingNumber="processingNumber"
                    @refresh-wayBillSummary="getWayBillSummaryData"
                    @refresh-taskSummary="getTaskSummaryData"
                    @isExpand="handleExpand"
                ></way-bill-summary>
            </div> -->
        </div>
        <!-- 分页 -->
        <div class="waybillNodeMonitorPagination">
            <m-page
                ref="page"
                :current-page="query.pageNo"
                :pageData="config.page"
                :total="pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
            ></m-page>
        </div>

        <!-- 日志弹窗 -->
        <waybill-node-daily-dialog
            ref="waybillNodeDaily"
            :waybillNodeDailyVisible.sync="waybillNodeDailyVisible"
            :rowData="rowData"
            v-if="waybillNodeDailyVisible"
        ></waybill-node-daily-dialog>
    </paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import MPage from '@/components/otpPanel/mPage';
import WaybillNodeMonitorSearch from './WaybillNodeMonitorSearch.vue';
import WaybillNodeMonitorTable from './WaybillNodeMonitorTable.vue';
import WaybillNodeDailyDialog from './WaybillNodeDailyDialog.vue';
import WayBillSummary from './WayBillSummary.vue';
import { I18nMixins } from '@/components/utils/i18n';
import { mapState } from 'vuex';
import {
    queryWaybillNodeMonitorList,
    queryCount,
    queryWayBillSummary,
    queryTaskSummary
} from '@/modules/transport/otp/api/performanceWaybillNodeMonitor.js';
import config from './config.js';
import { formatSearchData, formatSearchTime, validateSearchData, formatTaskSummaryData, dealWithExportParams } from './util.js';
export default {
    name: 'PerformanceWaybillNodeMonitor',
    mixins: [I18nMixins],
    components: {
        Paper,
        MPage,
        WaybillNodeMonitorSearch,
        WaybillNodeMonitorTable,
        WaybillNodeDailyDialog,
        WayBillSummary
    },
    data () {
        return {
            config,
            loading: false, // 列表加载动画
            isExpand: true, // 是否展开右侧运单汇总
            waybillNodeDailyVisible: false, // 是否显示日志弹窗
            searchId: 'searchListConfig', // 查询id
            columnLabelStr: '', // 列表label字段集合字符串
            pageTotal: 0, // 列表总条数
            processingNumber: 0, // 未完成订单数
            exceptionNumber: 0, // 异常订单数
            tableData: [], // 列表数据
            query: { pageNo: 1, pageSize: 10 }, // 分页
            rowData: {}, // 当前操作行数据
            isFirstSearch: true // 是否第一次查询
        };
    },
    // mounted () {
    //     this.getWayBillSummaryData();
    //     this.getTaskSummaryData();
    // },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier,
            user: state => state.user
        }),
        getSearchTime () { // 查询开始结束日期时间
            return formatSearchTime(this.$refs.waybillNodeMonitorSearch.$refs.searchList.searchData.searchTime);
        }
    },
    methods: {
        /**
         * @description 获取列表分页数据
         */
        getListPageCount () {
            queryCount(this.query).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },

        /**
         * @description 获取运单节点监控列表
         * @param 查询参数
         */
        getList () {
            this.loading = true;
            queryWaybillNodeMonitorList(this.query).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = this.formatWaybillNodeMonitorList(res.data.list || []);
                }
            }).finally(() => { this.loading = false; });
        },

        /**
         * @description 格式化运单节点监控列表数据
         * @param {Object} list 列表数据
         */
        formatWaybillNodeMonitorList (list) {
            list.forEach(v => {
                v.shippingType = v.shippingType + ''; // 发运类型
            });
            return list;
        },

        // 查询
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            if (!isQueryOk) return;
            this.query = this.getSearchData(_searchData);
            this.getList();
            this.getListPageCount();
            // this.getWayBillSummaryData();
            // this.getTaskSummaryData();
            this.isFirstSearch = false;
        },

        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    carrierCode: this.supplier.supplierCode, // 供应商编码-LSP
                    ...data
                }
            };
            return _searchData;
        },

        // 查看日志
        handleViewLog (row) {
            this.rowData = row;
            this.waybillNodeDailyVisible = true;
        },

        /**
         * @description 获取运单汇总
         */
        getWayBillSummaryData () {
            this.$refs.wayBillSummary.wayBillSummaryLoading = true;
            queryWayBillSummary(this.getSearchTime).then(res => {
                if (res && +res.code === 0) {
                    this.exceptionNumber = res.data.exceptionNumber || 0; // 异常运单数量
                    this.processingNumber = res.data.processingNumber || 0; // 未完成运单数量
                }
            }).finally(() => {
                this.$refs.wayBillSummary.wayBillSummaryLoading = false;
            });
        },

        /**
         * @description 获取任务汇总
         */
        getTaskSummaryData () {
            this.$refs.wayBillSummary.taskSummaryLoading = true;
            queryTaskSummary(this.getSearchTime).then(res => {
                if (res && +res.code === 0) {
                    const data = formatTaskSummaryData(res.data || []);
                    this.$refs.wayBillSummary.initEcharts(data);
                }
            }).finally(() => {
                this.$refs.wayBillSummary.taskSummaryLoading = false;
            });
        },

        // 展开右侧运单汇总
        handleExpand () {
            this.isExpand = !this.isExpand;
        },

        /**
         * @description 列配置发生改变时触发
         * @param {String} columnLabelStr 表格列配置label字段集合
         */
        tableConfigChange (columnLabelStr) {
            this.columnLabelStr = columnLabelStr;
        },

        // 导出
        handleExport (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.waybillNodeMonitorSearch.$refs.searchList.onSearchChange();
            const exportParams = dealWithExportParams(JSON.parse(JSON.stringify(this.query.param)));
            exportParams.tenantCode = this.currentTenant.tenantCode;
            submit(exportParams);
            this.isFirstSearch = false;
        },

        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },

        // 切换分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
<style lang="less">
.performanceWaybillNodeMonitor {
    width: 100%;
    overflow: hidden;
    padding-top: 6px;
    .el-dialog__header {
        text-align: left;
    }
    .waybillNodeMonitorWrapper {
        display: flex;
        justify-content: space-between;
        .el-table {
            min-height: calc(100vh - 160px);
            max-height: calc(100vh - 160px);
        }
        .waybillNodeMonitorRight {
            position: relative;
        }
    }
    .waybillNodeMonitorPagination {
        margin-top: 10px;
        overflow: hidden;
    }
    .tooltip {
        color: red;
        font-size: 13px;
        padding-bottom: 6px;
    }
}
</style>
